import React from 'react';
import { IconPlaylistAdd } from '@bynder/icons';
import { type BaseMultiPageModel, type TextElement } from '@bynder-studio/render-core';
import { useTranslate } from '@bynder/localization';
import { Dropdown, Form } from '@bynder/design-system';
import EditorColor from '../../../FormComponents/EditorColor';
import { useShotColor } from 'packages/pages/design/sidebar/shots/useShotColor';
import { useColorStyleModal } from '../../../FormComponents/EditorColor/components/modals/useColorStylesModal';

type Props = {
    isDisabled: boolean;
    selectedElement: TextElement;
    creativeModel: BaseMultiPageModel;
};

export const TextBackgroundBorderColor = ({ isDisabled, selectedElement, creativeModel }: Props) => {
    const textBackground = selectedElement.textBackground;
    const { translate } = useTranslate();
    const baseColorParams = {
        selectedElement,
        brandColorProperty: 'textBackground.borderBrandColors',
        propertyName: 'textBackground.borderColor',
    };
    const { appliedCustomColors, elementColors, onAppliedClick, handleChangeColor } = useShotColor({
        ...baseColorParams,
        creativeModel,
    });
    const { renderColorStylesModal, openConfigureColorsModal } = useColorStyleModal({
        ...baseColorParams,
        title: translate('editor.sidebar.shots.shape.border_color.configure.modal.title'),
    });

    if (!textBackground || !textBackground.borderColor) {
        return null;
    }

    return (
        <>
            <Form.Group>
                <Form.Label>{translate('editor.sidebar.shots.shape.border_color.label')}</Form.Label>
                <EditorColor
                    name="borderColor"
                    property="textBackground.borderColor"
                    color={textBackground.borderColor}
                    disabled={isDisabled}
                    onChange={handleChangeColor}
                    elementColors={elementColors}
                    onAppliedClick={onAppliedClick}
                    selectedCustomColors={appliedCustomColors}
                    testId="text_background_border_color"
                    selectedElement={selectedElement}
                    configureColorsButton={
                        <Dropdown.Item
                            isDisabled={isDisabled}
                            icon={<IconPlaylistAdd />}
                            onClick={openConfigureColorsModal}
                        >
                            {translate('editor.sidebar.shots.shape.configure-border-color-styles')}
                        </Dropdown.Item>
                    }
                />
            </Form.Group>
            {renderColorStylesModal()}
        </>
    );
};

export default TextBackgroundBorderColor;
